/**
 * Constants used across DeviceSpecifications components
 * Extracted from DeviceSpecifications.tsx
 */

// Price calculation debounce delay (ms)
export const PRICE_CALCULATION_DEBOUNCE_MS = 300;

// Processing animation delay (ms)
export const PROCESSING_ANIMATION_DELAY_MS = 4200;

// Processing text rotation interval (ms)
export const PROCESSING_TEXT_INTERVAL_MS = 600;

// Storage step index (always -1)
export const STORAGE_STEP_INDEX = -1;

